$(function () {
  var ua = navigator.userAgent;
  if ((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
    $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
  } else {
    $('head').prepend('<meta name="viewport" content="width=1366">');
  }
});

$(function () {
  var $elem = $('.posSwitch');
  var replaceWidth = 1001;
  function posSwitch() {
    var windowWidth = parseInt($(window).width());
    $elem.each(function () {
      var $this = $(this).find('.posSwitchTarget');
      var posFlgA = $(this).find('.posFlgA');
      var posFlgB = $(this).find('.posFlgB');
      if (windowWidth >= replaceWidth) {
        $this.appendTo(posFlgA);
      } else {
        $this.prependTo(posFlgB);
      }
    });
  }
  posSwitch();
  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      posSwitch();
    }, 100);
  });
});

$(function() {
  var showFlag = false;
  var ftBnr = $('.ft_bnr');    
  ftBnr.css('bottom', '-160px');
  var showFlag = false;
  //スクロールが100に達したらボタン表示
  $(window).on('scroll', function () {
      if ($(this).scrollTop() > 100) {
          if (showFlag == false) {
              showFlag = true;
              ftBnr.stop().animate({'bottom' : '20px'}, 500); 
          }
      } else {
          if (showFlag) {
              showFlag = false;
              ftBnr.stop().animate({'bottom' : '-160px'}, 500); 
          }
      }

      var scrollHeight = $(document).height();
      var scrollPosition = $(window).height() + $(window).scrollTop();
      var contactHeight = $("#contact").height();

      if (scrollHeight - scrollPosition  <= contactHeight) {
 
            ftBnr.fadeOut(500); 
        
    } else {
            ftBnr.fadeIn(500); 
    }

  });
  //スクロールしてトップ
  $(".ft_close").on('click', function () {
    ftBnr.hide();
  });
});

/*$(function() {
  var bnr = $('.contactBtn');
  //navの位置    
  var bnrTop = bnr.offset().top;
  //スクロールするたびに実行
  $(window).on('scroll', function () {
      var winTop = $(this).scrollTop();
      //スクロール位置がnavの位置より下だったらクラスfixedを追加
      if (winTop >= bnrTop) {
        bnr.addClass('fixed')
      } else if (winTop <= bnrTop) {
        bnr.removeClass('fixed')
      }
  });
});*/


    /*$(function() {
      var nav = $('.navArea');
      //表示位置
      var navTop = nav.offset().top+300;
      //ナビゲーションの高さ（シャドウの分だけ足してます）
      var navHeight = nav.height()+10;
      var showFlag = false;
      nav.css('top', '10px');
      //ナビゲーションの位置まできたら表示
      $(window).on('scroll', function () {
          var winTop = $(this).scrollTop();
          if (winTop >= navTop) {
              if (showFlag == false) {
                  showFlag = true;
                  nav
                      .addClass('fixed')
                      .stop().animate({'top' : '0px'}, 200);
              }
          } else if (winTop <= navTop) {
              if (showFlag) {
                  showFlag = false;
                  nav.stop().animate({'top' : '10px'}, 200, function(){
                      nav.removeClass('fixed');
                  });
              }
          }
      });
  });*/
